import { render, staticRenderFns } from "./gymBrenchPress.vue?vue&type=template&id=f6840c98&"
import script from "./gymBrenchPress.js?vue&type=script&lang=js&"
export * from "./gymBrenchPress.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports